$(document).ready(function () {
  $(".practitioner_form_button .button").click(function (event) {
    event.preventDefault();
    const __this = $(this).closest('form');
    $(".practitioner_form_button button").addClass("btn-loading");

    let isValid = true;
    let firstInvalid = null;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailField = $("#ContactForm-email");
    const emailError = $(".email-error-message");
    emailError.hide();

    // Clear previous errors
    $(".field__input, select, textarea").removeClass("input-error");

    // Validate fields in order
    $("#ContactForm [required]").each(function () {
      const el = $(this);
      const tag = el.prop("tagName").toLowerCase();
      const type = el.attr("type");
      let hasError = false;

      if (tag === "select") {
        const value = el.val();
        const isDisabledOption = el.find("option:selected").is(":disabled");
        if (!value || isDisabledOption) {
          hasError = true;
        }
      } else if (type === "email") {
        const val = el.val().trim();
        if (val && !emailRegex.test(val)) {
          emailError.show();
          hasError = true;
        } else if (val === '') {
          hasError = true;
        } else {
          emailError.hide();
        }
      } else if (type === "radio") {
        return;
      } else {
        if (!el.val().trim()) {
          hasError = true;
        }
      }

      if (hasError) {
        el.addClass("input-error");
        if (!firstInvalid) firstInvalid = el;
        isValid = false;
      }
    });

    // Validate radio groups
    const requiredRadios = [
      "primary-expertise",
      "certification-or-license",
      "interested-in-sampling-program"
    ];
    requiredRadios.forEach(function (name) {
      if (!$(`input[name='${name}']:checked`).length) {
        const el = $(`input[name='${name}']`).first();
        el.addClass("input-error");
        if (!firstInvalid) firstInvalid = el;
        isValid = false;
      }
    });

    // Validate "Other" text field if primary-expertise is "Other"
    const selectedExpertise = $("input[name='primary-expertise']:checked").val();
    const expertiseOtherField = $("input[name='contact[area-of-expertise]']");
    if (selectedExpertise === "Other") {
      const otherExpertise = expertiseOtherField.val().trim();
      if (!otherExpertise) {
        expertiseOtherField.addClass("input-error");
        if (!firstInvalid) firstInvalid = expertiseOtherField;
        isValid = false;
      }
    }

    // Validate digital presence checkboxes
    const digitalPresenceCheckboxes = $("#ContactForm input[type='checkbox'][name^='digital-presence']");
    const digitalPresenceOther = $("input[name='contact[digital-presence-other]']");
    const digitalPresenceUrls = $("input[name='contact[digital-presence-urls]']");
    const digitalPresenceError = $(".digital-presence-error-message");

    let digitalPresenceSelected = [];

    digitalPresenceCheckboxes.each(function () {
      if ($(this).is(":checked")) {
        digitalPresenceSelected.push($(this).val());
      }
    });

    const otherPresenceValue = digitalPresenceOther.val().trim();
    if (otherPresenceValue) {
      digitalPresenceSelected.push("Other: " + otherPresenceValue);
    }

    const urlsValue = digitalPresenceUrls.val().trim();
    if (urlsValue) {
      digitalPresenceSelected.push("URLs: " + urlsValue);
    }

    if (digitalPresenceSelected.length === 0) {
      digitalPresenceCheckboxes.first().addClass("input-error");
      digitalPresenceOther.addClass("input-error");
      digitalPresenceError.show();
      if (!firstInvalid) firstInvalid = digitalPresenceCheckboxes.first();
      isValid = false;
    } else {
      digitalPresenceCheckboxes.removeClass("input-error");
      digitalPresenceOther.removeClass("input-error");
      digitalPresenceError.hide();
    }

    if (!isValid) {
      $(".practitioner_form_button button").removeClass("btn-loading");
      firstInvalid[0].scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      firstInvalid.focus();
      return;
    }

    const formData = {
      fullName: $("#ContactForm-name").val().trim(),
      email: $("#ContactForm-email").val().trim(),
      professionalTitle: $("#ContactForm-practitioner-Professional").val(),
      businessName: $("#ContactForm-practice-name[name='contact[practice-name]']").val().trim(),
      expertise: selectedExpertise === "Other" ? expertiseOtherField.val().trim() : selectedExpertise,
      certification: $("input[name='certification-or-license']:checked").val(),
      city: $("#ContactForm-practice-city").val().trim(),
      digitalPresence: digitalPresenceSelected.join(", "),
      earnCommission: $("input[name='interested-in-earning-commission']:checked").val(),
      contributeContent: $("input[name='interested-in-social-media-channels']:checked").val(),
      samplingInterest: $("input[name='interested-in-sampling-program']:checked").val(),
      whyInterested: $("#ContactForm-body-community").val().trim(),
      hearAboutUs: $("#ContactForm-practitioner-about-us").val(),
    };

    console.log("✅ Form is valid. Sending to Google Sheets...", formData);

    // Example: Send via AJAX to Google Sheets
    const scriptURL = "https://script.google.com/macros/s/AKfycbxwmWqiQtspBD3Ou4w9Tozcku5S5MjVcqAaB8wWzLke5Qb2sjxVoxSX-HwnfvJvH-LV/exec";
    $.ajax({
      url: scriptURL,
      method: "POST",
      data: formData,
      success: function (response) {
        console.log("Data sent to Google Sheets: " + response);
        $(".practitioner_form_button button").removeClass("btn-loading");
        __this.submit();
      },
      error: function (error) {
        console.error("Error sending data to Google Sheets:", error);
        $(".practitioner_form_button button").removeClass("btn-loading");
      }
    });
  });

  // Real-time error clearing for digital presence
  $("#ContactForm input[type='checkbox'][name^='digital-presence'], input[name='contact[digital-presence-other]']").on("change keyup", function () {
    if (
      $("#ContactForm input[type='checkbox'][name^='digital-presence']").is(":checked") ||
      $("input[name='contact[digital-presence-other]']").val().trim() !== ""
    ) {
      $("#ContactForm input[type='checkbox'][name^='digital-presence']").removeClass("input-error");
      $("input[name='contact[digital-presence-other]']").removeClass("input-error");
      $(".digital-presence-error-message").hide();
    }
  });
});